import { render, staticRenderFns } from "./FormLibrary.vue?vue&type=template&id=b2a0b74a"
import script from "./FormLibrary.vue?vue&type=script&lang=js"
export * from "./FormLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports